import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { Accordion } from "@website/ui/accordion";
type FAQItem = {
  question: string;
  answer: string;
};
export type FaqProperties = {
  data: Array<FAQItem>;
};
export const Faq = properties => {
  const $ = _c(5);
  const {
    data
  } = properties;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex items-center gap-x-2"><div className="text-on-surface-medium-emphasis flex items-center text-2xl"><MaterialIcon name="help_outline" /></div><h4 className="text-on-surface-high-emphasis text-headline-6">سوالات متداول{" "}</h4></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== data) {
    t1 = data.map(_temp);
    $[1] = data;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="flex flex-col gap-y-4">{t0}{t1}</div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
function _temp(item) {
  return <Accordion content={item.answer} key={item.question} title={item.question} />;
}